// app/context/theme-context.tsx
'use client';
import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ThemeContextType {
  themeColor: string;
  setThemeColor: (color: string) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [themeColor, setThemeColor] = useState<string>('#1e293b'); // dark default

  useEffect(() => {
    const stored = localStorage.getItem('themeColor');
    if (stored) setThemeColor(stored);
  }, []);

  const handleSetThemeColor = (color: string) => {
    setThemeColor(color);
    localStorage.setItem('themeColor', color);
  };

  return (
    <ThemeContext.Provider value={{ themeColor, setThemeColor: handleSetThemeColor }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within ThemeProvider');
  return context;
};
